import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { GeneralService } from './general.service';
import { MessageService } from 'primeng/components/common/messageservice';
import { environment } from '../../environments/environment';
import { PersistenceService } from 'angular-persistence';
import { SelectItem } from 'primeng/primeng';

@Injectable()
export class TransferRoutingService extends GeneralService {
    constructor(protected messageService: MessageService, protected httpClient: HttpClient, protected persistenceService: PersistenceService) {
        super(messageService, httpClient, persistenceService, environment.apiGeneralUrl, "transferRouting");
    }
    public async getSelectModelAllAsync(): Promise<SelectItem[]> {
        const res = await this.getAllAsync();
        const data: SelectItem[] = [];
        if (res) {
            res.forEach(element => {
                data.push({ label: element.name, value: element.id });
            });
            return data;
        } else {
            return data;
        }
    }

    async getListTransferRouting(model:any){
    let res = await this.postCustomApi('getListTransferRouting',model).toPromise();
    if(!this.isValidResponse(res)) return;
    return res.data;
    }
}
